import gui			from "gui";
import Dialog		from "dialog";
import template		from "../html/dialog-usermanager.html";
import css			from "../css/dialog-usermanager.css";
import DataTable	from "datatable";

class UsermanagerDialog extends Dialog {
	static get template() {
			return template;
	}
	static get css() {
			return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-usermanager", UsermanagerDialog);
	}
	static get schema() {
		return({
			"type": "object",
			"description": "Label Control displays text.",
			"properties": {
				"text": {
					"type": "string",
					"description": "Text content of the Label Control",
					"default": "Label #n"
				}
			}
		});
	}
	static get designer() {
		return({
			"category": "Basic",
			"icon": {"context": "actions", "size": 16, "iconname": "insert-text"}
		});
	}
	constructor() {
		super();

		this.show();
	}
	buttonAddUser_click(event) {
		var row = this.datatableUserlist.appendChild( new DataTable.Row() );
		row.appendChild( new DataTable.Cell() );
		row.appendChild( new DataTable.Cell() );
		row.appendChild( new DataTable.Cell() );
		row.appendChild( new DataTable.Cell() );

		row.setAttribute("action", "add");
	}
	buttonRemoveUser_click(event) {
		console.log("removeuser", this.datatableUserlist.selectedIndex);
		if (this.datatableUserlist.selectedIndex<1) {
			alert("Please select a user to delete");
			return;
		}

		this.datatableUserlist.children[this.datatableUserlist.selectedIndex].setAttribute("action", "remove");
	}
	buttonEditUser_click(event) {
		if (this.datatableUserlist.selectedIndex<1) {
			alert("Please select a user to edit");
			return;
		}

		var i = this.datatableUserlist.selectedIndex;
		console.log(i);
		this.datatableUserlist.children[i].setAttribute("action", "update");
		this.datatableUserlist.children[i].children[1].disabled = false;
		this.datatableUserlist.children[i].children[2].disabled = false;
		this.datatableUserlist.children[i].children[3].disabled = false;
	}
	buttonSave_click() {
		// create and dispatch the event
		var event = new CustomEvent("change", {
			detail: {
				url: this.url
			}
		});
		this.dispatchEvent(event);
		
		if (typeof this.onchange=="function") {
			this.onchange(event);
		}
		
		var requests = [];
		
		var items = [].slice.call(this.datatableUserlist.children);

		for (var i=0; i<items.length; i++) {
		
			var action = this.datatableUserlist.children[i].getAttribute("action");
			
			switch (action) {
				case "update":
					requests.push(server.rcall("RM_user_modify", {
						username:	this.datatableUserlist.cell(i, 0).value,
						fullname: 	this.datatableUserlist.cell(i, 1).value,
						role: 		this.datatableUserlist.cell(i, 2).value,
						password:	this.datatableUserlist.cell(i, 3).value
					}).then(function(row) {
					    row.removeAttribute("action");
					}.bind(this, this.datatableUserlist.children[i])));
				break;
				case "remove":
					requests.push(server.rcall("RM_user_remove",
						this.datatableUserlist.cell(i, 0).value
					).then(function(row) {
						row.remove();
					    /*row.removeAttribute("action");*/
					}.bind(this, this.datatableUserlist.children[i])));
				break;
				case "add":
					requests.push(server.rcall("RM_user_add", {
						username:	this.datatableUserlist.cell(i, 0).value,
						fullname: 	this.datatableUserlist.cell(i, 1).value,
						role: 		this.datatableUserlist.cell(i, 2).value,
						password:	this.datatableUserlist.cell(i, 3).value
					}).then(function(row) {
					    row.removeAttribute("action");
					}.bind(this, this.datatableUserlist.children[i])));
				break;
			}
		}
		
		Promise.all(requests).then(function(results) {
			/*this.close();*/
		}.bind(this)).catch(function(results) {
			alert(results);
		}.bind(this));

	}
	buttonClose_click() {
		this.close();
	}
	show() {
		super.show();
		
		this.list_users();
	}
	list_users() {
		server.rcall("RM_listusers")
		.then(function(users) {
				Object.keys(users).forEach(function(username) {
						var row = this.datatableUserlist.appendChild( new DataTable.Row() );
						row.appendChild( new DataTable.Cell({"value": username, "disabled": true}) );
						row.appendChild( new DataTable.Cell({"value": users[username].fullname, "disabled": true}) );
						row.appendChild( new DataTable.Cell({"value": users[username].role, "disabled": true}) );
						row.appendChild( new DataTable.Cell({"value": users[username].password, "disabled": true}) );
				}, this);

		}.bind(this))
		.catch(function(message) {
				alert(message);
		}.bind(this));
	}
}

UsermanagerDialog.constructor();

export default UsermanagerDialog;